var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 438,
    viewBox: "0 0 439 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2600_1300)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M351.745 175.716H273.048C267.234 175.716 262.523 171.01 262.523 165.201V86.5756H175.877V165.201C175.877 171.01 171.166 175.716 165.352 175.716H86.6547V262.284H165.352C171.166 262.284 175.877 266.99 175.877 272.799V351.424H262.523V272.799C262.523 266.99 267.234 262.284 273.048 262.284H351.745V340.214C351.745 350.098 347.611 359.527 340.349 366.231L262.523 438L175.877 351.432H97.8755C87.9823 351.432 78.5451 347.301 71.8351 340.046L0 262.284L86.6467 175.716V97.7861C86.6467 87.902 90.7815 78.4734 98.0434 71.7695L175.877 0L262.523 86.5676H340.525C350.418 86.5676 359.855 90.6987 366.565 97.9539L438.4 175.708L419.526 194.565L351.753 262.276V175.708L351.745 175.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6467 175.716V262.284H0L86.6467 175.716ZM175.877 351.424H262.523V437.992L175.877 351.424ZM351.745 262.284V175.716H438.392L351.745 262.284ZM262.523 86.5676H175.877V0L262.523 86.5676Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_1300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 439,
    height: 438,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrata);
export default __webpack_public_path__ + "static/media/strata.82be7a95654a4bb5d5604f286ec10fc5.svg";
export { ForwardRef as ReactComponent };